<div class="content">
  <kendo-grid
    [data]="huntStateService.results | async"
    kendoGridSelectBy="id"
    [pageSize]="(huntStateService.huntState | async).take"
    [skip]="(huntStateService.huntState | async).skip"
    (dataStateChange)="onHuntPageChange($event)"
    [pageable]="true"
    [filterable]="true"
    [filter]="(huntStateService.huntState | async).filter"
    [sortable]="true"
    [sort]="(huntStateService.huntState | async).sort"
    [selectable]="false"
    [groupable]="false"
    [reorderable]="true"
    [resizable]="true"
  >
    <ng-template kendoGridToolbarTemplate>
      <hyperkit-button
        size="small"
        (click)="clearAllFilters()"
        variant="standard"
        color="secondary"
        icon="filter"
        text="Clear All Filters"
      ></hyperkit-button>
      @if (!(huntStateService.huntState | async).archived) {
        <hyperkit-button
          size="small"
          (click)="toggleArchivedHunts()"
          variant="link"
          color="primary"
          icon="filter"
          text="View Archived"
        ></hyperkit-button>
      }
      @if ((huntStateService.huntState | async).archived) {
        <hyperkit-button
          size="small"
          (click)="toggleArchivedHunts()"
          variant="standard"
          color="secondary"
          iconPosition="right"
          icon="x"
          text="Archived"
        ></hyperkit-button>
      }
      <kendo-grid-spacer></kendo-grid-spacer>
    </ng-template>
    <kendo-grid-column field="name" title="Hunt Name" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [showOperators]="false"
          [column]="column"
          [filter]="(huntStateService.huntState | async).filter"
        >
        </kendo-grid-string-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.archived) {
          <hyperkit-typography variant="emphasized" size="sm" color="body">
            {{ dataItem.name }}
          </hyperkit-typography>
        } @else {
          @if (dataItem.huntPackages && dataItem.huntPackages.length > 0) {
            <hyperkit-link
              display="inline"
              [routerLink]="getRouterLink(dataItem)"
              variant="emphasized"
              size="sm"
              color="primary"
              text=" {{ dataItem.name }}"
            >
            </hyperkit-link>
          } @else {
            <hyperkit-link
              display="inline"
              routerLink="/hunt/{{ dataItem.id }}"
              variant="emphasized"
              size="sm"
              color="primary"
              text=" {{ dataItem.name }}"
            >
            </hyperkit-link>
            <!-- <a class="link" routerLink="/hunt/{{ dataItem.id }}">{{
            dataItem.name
          }}</a> -->
          }
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="huntTemplate" title="Hunt Template" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [showOperators]="false"
          [column]="column"
          [filter]="(huntStateService.huntState | async).filter"
        >
        </kendo-grid-string-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (
          dataItem.archived ||
          (dataItem.huntTemplate && dataItem.huntTemplate.archived)
        ) {
          <hyperkit-typography variant="emphasized" size="sm" color="body">
            {{ dataItem.name }}
          </hyperkit-typography>
        } @else {
          @if (dataItem.huntTemplate) {
            <hyperkit-link
              display="inline"
              [disabled]="(huntStateService.huntState | async).archived"
              routerLink="/hunt/hunt-template/{{ dataItem.huntTemplate.id }}"
              variant="emphasized"
              size="sm"
              color="primary"
              text=" {{ dataItem.huntTemplate.name }}"
            >
            </hyperkit-link>
          }
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="environments" title="Environments" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <multiselect-environment-filter
          #hunt_env_multiselect
          [filter]="(huntStateService.huntState | async).filter"
          field="environments"
          [data]="environments"
          textField="name"
          valueField="id"
        ></multiselect-environment-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.environments) {
          @for (env of dataItem.environments; track env; let isLast = $last) {
            <hyperkit-link
              display="inline"
              routerLink="/settings/environment"
              variant="emphasized"
              size="sm"
              color="primary"
              text="{{ env.name }}"
            >
            </hyperkit-link>
            @if (!isLast) {
              <span>, </span>
            }
          }
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="status"
      title="Status"
      [width]="190"
      [class]="{ 'text-center': true }"
      [resizable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <multiselect-tag-filter
          #hunt_multiselect
          [filter]="(huntStateService.huntState | async).filter"
          field="status"
          [data]="statusFilters"
          textField="text"
          valueField="value"
        ></multiselect-tag-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <hyperkit-badge
          [variant]="dataItem.status | statusBadge"
          [text]="dataItem.status"
        ></hyperkit-badge>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="queryStatus"
      title="Progress"
      [width]="190"
      [filterable]="false"
      [sortable]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (getTotalQueries(dataItem) > 0) {
          <hyperkit-segmented-progress-bar
            [segments]="getProgressSegments(dataItem)"
            [showLabels]="false"
            size="small"
          ></hyperkit-segmented-progress-bar>
        } @else {
          <hyperkit-typography variant="body" size="sm" color="primary">
            No queries
          </hyperkit-typography>
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="priority"
      title="Priority"
      [width]="190"
      [class]="{ 'text-center': true }"
      [resizable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <multiselect-tag-filter
          #hunt_multiselect
          [filter]="(huntStateService.huntState | async).filter"
          field="priority"
          [data]="priorityFilters"
          textField="text"
          valueField="value"
        ></multiselect-tag-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <hyperkit-badge
          [variant]="dataItem.priority | priorityBadge"
          [text]="dataItem.priority"
        ></hyperkit-badge>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="outcome"
      title="Outcome"
      [width]="190"
      [class]="{ 'text-center': true }"
      [resizable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <multiselect-tag-filter
          #hunt_multiselect
          [filter]="(huntStateService.huntState | async).filter"
          field="outcome"
          [data]="outcomeFilters"
          textField="text"
          valueField="value"
        ></multiselect-tag-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.outcome) {
          <hyperkit-badge
            [variant]="dataItem.outcome | outcomeBadge"
            [text]="dataItem.outcome"
          ></hyperkit-badge>
        }
      </ng-template>
    </kendo-grid-column>
    <!-- <kendo-grid-column field="created" title="Created" [width]="110">
  <ng-template kendoGridCellTemplate let-dataItem>
    {{ dataItem.created | date: 'longDate' }}
  </ng-template>
</kendo-grid-column> -->
    <kendo-grid-column field="created" title="Created" [width]="230">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <date-range-filter
          #hunt_datepicker
          class="date-range-filter"
          [filter]="(huntStateService.huntState | async).filter"
          field="created"
        >
        </date-range-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created | date: 'longDate' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="author" title="Author" [width]="130">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dropdown-filter
          #hunt_dropdown
          [filter]="(huntStateService.huntState | async).filter"
          field="author"
          [data]="users$ | async"
          textField="fullName"
          valueField="id"
        ></dropdown-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.author) {
          <span
            >{{ dataItem.author?.firstName }}
            {{ dataItem.author?.lastName }}</span
          >
        } @else {
          (deleted)
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="assignee" title="Assignee" [width]="130">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <dropdown-filter
          #hunt_dropdown
          [filter]="(huntStateService.huntState | async).filter"
          field="assignee"
          [data]="users$ | async"
          textField="fullName"
          valueField="id"
        ></dropdown-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.assignee) {
          <span
            >{{ dataItem.assignee?.firstName }}
            {{ dataItem.assignee?.lastName }}</span
          >
        } @else {
          Unassigned
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      [sortable]="false"
      [filterable]="false"
      field="id"
      title=""
      [width]="130"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (!(huntStateService.huntState | async).archived) {
          <hyperkit-button
            size="small"
            (click)="archiveHunt(dataItem)"
            variant="standard"
            color="secondary"
            text="Archive"
          ></hyperkit-button>
        }
        @if ((huntStateService.huntState | async).archived) {
          <hyperkit-button
            size="small"
            (click)="unarchiveHunt(dataItem)"
            variant="standard"
            color="secondary"
            text="Unarchive"
          ></hyperkit-button>
        }
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
